/* eslint-disable no-console */
import { consumerApiAxiosInstance } from 'config/consumerApiAxiosInstance'
import { getToken } from 'services/amplify/auth'
import convertKeys from 'utils/convert-keys'

export const getDataBrokerRemovalContract = async () => {
  const token = await getToken()
  try {
    const response = await consumerApiAxiosInstance(token).get('/data-broker-removal/contract')
    return convertKeys.toCamel(response.data)
  } catch (error) {
    console.error('[Data Broker Removal Contract] Error retrieving contract:', error)
    return null
  }
}

export const requestDataBrokerRemovalContract = async () => {
  const token = await getToken()
  try {
    const response = await consumerApiAxiosInstance(token).post('/data-broker-removal/contract')
    return convertKeys.toCamel(response.data)
  } catch (error) {
    console.error('[Data Broker Removal Contract] Request failed:', error)
    return null
  }
}

export const deleteDataBrokerRemovalContract = async () => {
  const token = await getToken()
  try {
    const response = await consumerApiAxiosInstance(token).delete('/data-broker-removal/contract')
    return response.status >= 200 && response.status < 300
  } catch (error) {
    console.error('[Data Broker Removal Contract] Deletion failed:', error)
    return false
  }
}
